import React from 'react'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { Button } from '../../../../components/Button/Button'
import { useKeyboardNavigation } from '../../../../common/useKeyboardNavigation'

export interface CrossClientResultNavButtonsProps {
  hasPreviousResult: boolean
  hasNextResult: boolean
  handlePreviousResult: () => void
  handleNextResult: () => void
}

export const CrossClientResultNavButtons: React.FC<CrossClientResultNavButtonsProps> = ({
  hasPreviousResult,
  hasNextResult,
  handlePreviousResult,
  handleNextResult,
}) => {
  useKeyboardNavigation({
    onNext: handleNextResult,
    onPrevious: handlePreviousResult,
    enableNext: hasNextResult,
    enablePrevious: hasPreviousResult,
  })

  return (
    <div className='d-flex gap-3 align-items-center'>
      <Tooltip className='zocks-text-gray-500' placement='top' title='Previous Client'>
        <Button variant='header' className='px-2 zocks-border-0.5 zocks-border-color-gray-300' disabled={!hasPreviousResult} onClick={handlePreviousResult}>
          <i className='bi bi-chevron-left' />
        </Button>
      </Tooltip>
      <Tooltip className='zocks-text-gray-500' placement='top' title='Next Client'>
        <Button variant='header' className='px-2 zocks-border-0.5 zocks-border-color-gray-300' disabled={!hasNextResult} onClick={handleNextResult}>
          <i className='bi bi-chevron-right' />
        </Button>
      </Tooltip>
    </div>
  )
}
